var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Button from "../Button/Button";
import Heading from "../Heading";
import Markdown from "../Markdown";
import ToggleSwitch from "../ToggleSwitch";
import React, { useState, useRef } from 'react';
import { CookieContent, StyledCookieDetails, StyledHeader } from "./CookiesStyle";
var CookiesDetailsOptional = function (_a) {
    var title = _a.title, description = _a.description, setOptionalCookies = _a.setOptionalCookies, optionalCookies = _a.optionalCookies, cookies = _a.cookies, moreInfoLabel = _a.moreInfoLabel, lessInfoLabel = _a.lessInfoLabel, index = _a.index;
    var checked = optionalCookies && index !== undefined && optionalCookies[index].checked.toString();
    var _b = useState(false), showMoreInfo = _b[0], setShowMoreInfo = _b[1];
    var _c = useState(checked !== 'false'), optionalCookiesToggle = _c[0], setOptionalCookiesToggle = _c[1];
    var inputRef = useRef(null);
    var handleToggleOptionalCookie = function (e) {
        if (setOptionalCookies && optionalCookies && index !== undefined) {
            var newArr = __spreadArrays(optionalCookies);
            newArr[index].checked = e.target.checked;
            setOptionalCookies(newArr);
        }
        setOptionalCookiesToggle(function (prevState) { return !prevState; });
        if (inputRef.current) {
            inputRef.current.checked = e.target.checked;
        }
    };
    return (React.createElement(StyledCookieDetails, null,
        React.createElement(StyledHeader, null,
            React.createElement(Heading.Heading6, { fontWeight: "extraBold" }, title),
            React.createElement(ToggleSwitch, { ref: inputRef, name: title, checked: optionalCookiesToggle, onChange: handleToggleOptionalCookie })),
        React.createElement(Markdown, { children: description }),
        showMoreInfo && (React.createElement(CookieContent, null,
            React.createElement("table", { className: "responsive-table" },
                React.createElement("tbody", null,
                    React.createElement("tr", { key: cookies.Name }, Object.entries(cookies).map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return (React.createElement("td", { key: key, "data-label": key },
                            React.createElement("span", null, value || '-')));
                    })))))),
        React.createElement(Button, { ghost: true, onClick: function () { return setShowMoreInfo(function (prevState) { return !prevState; }); } }, !showMoreInfo ? moreInfoLabel : lessInfoLabel),
        React.createElement("hr", null)));
};
export default CookiesDetailsOptional;
//# sourceMappingURL=CookiesDetailsOptional.js.map